import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotifService } from './shared/notif.service';
import { APP_VERSION } from './version';

@Injectable()
export class NotifInterceptor implements HttpInterceptor {

  constructor(private notifService:NotifService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body && event.body.notif) {
            const notifications = event.body.notif;
            if (notifications.length)
              this.notifService.updateNotifications(notifications);
          }
          // Désactivé : la bannière de mise à jour est gérée par version.json et le SW hash check
          // if (event instanceof HttpResponse && event.body && event.body.version && (event.body.version > APP_VERSION)) {
          //   this.notifService.displayNewVersion(event.body.version);
          //   window.scroll(0,0);
          // }
        },
        (error: any) => {
          if (error.error?.notif?.length)
            this.notifService.updateNotifications(error.error.notif);
        }
      )
    );
  }
}
